<template>
  <el-config-provider :locale="zhCn">
    <router-view></router-view>
  </el-config-provider>

</template>

<script>
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn'

export default {
  name: 'App',
  components: {
    ElConfigProvider,

  },
  data(){
    return{
      zhCn:""
    }
  },
  beforeMount(){
    this.zhCn = zhCn;
    this.$i18n.locale = localStorage.getItem('lang') || 'zh';
  }
}
</script>

<style>
body{
  margin: 0 !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  text-align: center;
  color: #909399;
  font-size: 14px;
}
@media screen  and (min-width: 961px) {
  min-width:1280px !important;
}
</style>
